{
  "DATE_PICKER": {
    "PREVIOUS_PERIOD": "Previous period",
    "NEXT_PERIOD": "Next period",
    "WEEK_NUMBER": "Week #{weekNumber}",
    "APPLY_BUTTON": "Confirmar",
    "CLEAR_BUTTON": "Limpar",
    "DATE_RANGE_INPUT": {
      "START": "Data inicial",
      "END": "Data final"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "Intervalo de datas",
      "LAST_7_DAYS": "Últimos 7 Dias",
      "LAST_30_DAYS": "Últimos 30 Dias",
      "LAST_3_MONTHS": "Últimos 3 meses",
      "LAST_6_MONTHS": "Últimos 6 meses",
      "LAST_YEAR": "Último ano",
      "THIS_WEEK": "This week",
      "MONTH_TO_DATE": "This month",
      "CUSTOM_RANGE": "Intervalo de tempo personalizado"
    }
  }
}
